export const TOOLTIP_DESCRIPTION = 'This amount may not be included in PPP Schedule A Worksheet, Table 1 or 2.';
export const TOOLTIP_NAME = 'owner-compensation-total-tooltip';
export const MAX_AMOUNT_THRESHOLD = 20833;
